import { useSiteConfig } from "@context/siteConfig";
import ChevronIcon from "@icons/chevron.svg";
import clsx from "clsx";
import React from "react";
import ReactPaginate from "react-paginate";
import styles from "./Pagination.module.scss";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const { isRtl, isMobile } = useSiteConfig();
  const handleOnPageChange = (selectedItem: { selected: number }): void => {
    onPageChange(selectedItem.selected + 1);
  };
  return (
    <div className={clsx(styles.container, isRtl && styles.rtl)}>
      <ReactPaginate
        disableInitialCallback={true}
        onPageChange={handleOnPageChange}
        initialPage={currentPage - 1}
        pageCount={totalPages}
        pageClassName={styles.pageNumber}
        previousLabel={<ChevronIcon />}
        nextLabel={<ChevronIcon />}
        marginPagesDisplayed={isMobile ? 0 : 1}
        pageRangeDisplayed={isMobile ? 2 : 4}
        containerClassName={styles.container}
        pageLinkClassName={styles.pageLinkClassName}
        previousLinkClassName={styles.pageLinkClassName}
        nextLinkClassName={styles.pageLinkClassName}
        activeClassName={styles.active}
        breakLabel={"..."}
        nextClassName={clsx(styles.next, isRtl && styles.rtl)}
        previousClassName={clsx(styles.prev, isRtl && styles.rtl)}
        breakClassName={styles.breakItem}
      />
    </div>
  );
};

export default Pagination;
